import Page from 'components/modules/public/pages/Jobs';
export default Page;